import { CourseDto } from "../../types/course.dto";
import { useTheme } from "styled-components";
import { Card, Thumbnail, Link, Typography, Bg, Bg2, Bg3 } from "./styles";
import { Flex } from "../StyledComponents";

import Progress from "./components/Progress";
import Valoration from "./components/Valoration";
import Continue from "./components/Continue";

import Icon from "../Icon";

import InformationCircleIcon from "../../assets/icons/icon-cool/filled/InformationCircle.svg";

interface ComponentProps {}

const Component = ({}: ComponentProps) => {
  return (
    <Card>
      <Bg />
      <Bg2 />
      <Bg3 />
      <Flex
        gap={16}
        justify="space-between"
        style={{ position: "relative", zIndex: "10" }}
      >
        <Thumbnail background={""} />

        <Flex gap={8} column>
          <Flex justify="space-between" style={{ minHeight: 39 }}>
            <Typography as="h5" size="sm" width={100} height={16} />

            <Flex width={37} justify="flex-end">
              <Progress shape="ring" current={3} total={6} showNumber />
            </Flex>
          </Flex>

          {/* <Typography as="p" size="xs">{enrollment.course.description}</Typography> */}
          <Flex align="center" gap={5}>
            <Typography as="p" size="xs" width={62} height={13} />
            <Icon icon={InformationCircleIcon} size="12px" color="#f1f4f9" />
          </Flex>

          <Flex gap={5}>
            <Flex column gap={3}>
              <Flex justify="space-between" aligne="center">
                <Flex gap={5}>
                  <Typography as="p" size="xs" width={25} height={16} />
                  <Typography as="p" size="xs" width={55} height={16} />
                </Flex>

                <Valoration value={3} />
              </Flex>

              <Progress shape="bar" current={2} total={5} />
            </Flex>
            <Continue />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};

export default Component;
